export default __webpack_public_path__ + "static/media/giada-logo.6d4d0d13.svg";